var _rect, _circle, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInvalidExpirationDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 120,
    height: 120,
    rx: 60,
    fill: "#7B66F2",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60,
    r: 44,
    fill: "#7B66F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0486 72H78.9512C79.8907 71.9989 80.7916 71.6624 81.4567 71.0645C82.1215 70.4662 82.4965 69.6552 82.4998 68.8085V54.5789C82.4999 54.5744 82.5 54.5699 82.5 54.5653V50.4349C82.5 50.4303 82.4999 50.4258 82.4998 50.4212V47.1915C82.4966 46.3448 82.1215 45.5338 81.4567 44.9355C80.7915 44.3376 79.8907 44.0011 78.9512 44H42.0486C41.109 44.0011 40.2082 44.3376 39.543 44.9355C38.8783 45.5338 38.5032 46.3448 38.5 47.1915V68.8085C38.5032 69.6552 38.8783 70.4662 39.543 71.0645C40.2083 71.6624 41.109 71.9989 42.0486 72ZM39.4053 55.0001V68.8093C39.4061 69.4408 39.6845 70.0464 40.1804 70.4929C40.6758 70.9397 41.3479 71.1906 42.0487 71.1914H78.9512C79.652 71.1906 80.3241 70.9397 80.8195 70.4929C81.3154 70.0464 81.5938 69.4409 81.5946 68.8093V55.0001H39.4053ZM39.4053 50.0001H81.5946V47.1923C81.5938 46.5608 81.3154 45.9552 80.8195 45.5087C80.3241 45.0619 79.652 44.811 78.9512 44.8103L42.0486 44.8165C41.3491 44.8168 40.6783 45.0674 40.1828 45.5124C39.6873 45.9577 39.4077 46.5619 39.4053 47.1923V50.0001ZM81.5946 50.8697H39.4058V54.1305H81.5946V50.8697Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 36.5,
    y: 58,
    width: 22,
    height: 9,
    rx: 2,
    stroke: "white",
    strokeWidth: 1.2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInvalidExpirationDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/invalid-expiration-date.eb0f046b1d139af589d345b8478f0aef.svg";